import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import HighchartsVue from "highcharts-vue";
import VueApexCharts from "vue-apexcharts";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
highchartsMore(Highcharts);
Vue.use(HighchartsVue);
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
